module.exports = __webpack_public_path__ + "img/camara-municipal.be8a7421.jpg";